import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetUserPerformanceReport } from "../services/reports.services";

const UserPerformanceReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/userperformancereportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/userperformancereportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterSector = params?.filterSector;
  const InquiryType = params?.InquiryType;
  const BranchIDs = params?.BranchIDs;
  const DateType = params?.DateType;

  const loading = useAppSelector((state) => state.reports.loading);
  const UserPerformanceListForReport = useAppSelector(
    (state) => state.reports.UserPerformanceListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        DestinationID: filterSector !== "0" ? filterSector : 0,
        TypeofInquiry: InquiryType !== "0" ? InquiryType : "",
        DateType: DateType !== "0" ? DateType : "",
        BranchIDs: BranchIDs !== "0" ? BranchIDs : "",
      };
      dispatch(GetUserPerformanceReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "UserPerformanceReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "userperformancereport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          User Performance Report{" "}
          <span style={{ fontSize: 15 }}>
            {UserPerformanceListForReport &&
              UserPerformanceListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            UserPerformanceListForReport &&
            UserPerformanceListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            UserPerformanceListForReport &&
            UserPerformanceListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {UserPerformanceListForReport &&
      UserPerformanceListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  User Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Follow-Ups Done
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Quotations Sent
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Inquiries Won
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Inquiries Lost
                </th>
                {/* <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Booking
                </th> */}
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Revenue Generated
                </th>
              </tr>
            </thead>
            <tbody>
              {UserPerformanceListForReport &&
                UserPerformanceListForReport.length > 0 &&
                UserPerformanceListForReport?.map(
                  (UserPerformance: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {UserPerformance?.UserName || ""}
                      </td>
                      <td className="text-center">
                        {UserPerformance?.FollowupsDone || ""}
                      </td>
                      <td className="text-center">
                        {UserPerformance?.QuotationSent || ""}
                      </td>
                      <td className="text-center">
                        {UserPerformance?.InquiryWon || ""}
                      </td>
                      <td className="text-center">
                        {UserPerformance?.InquiryLost || ""}
                      </td>
                      {/* <td className="text-center">
                        {UserPerformance?.TotalBooking || ""}
                      </td> */}
                      <td className="text-end">
                        {UserPerformance?.TotalRevenue
                          ? formatIndianNumber(UserPerformance?.TotalRevenue)
                          : ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default UserPerformanceReportView;
